module.exports = __webpack_public_path__ + "media/images/vp/samples/27-218c455d76828b3dc444991c6587472d.jpg";